//Depends on Table component and jQuery

//add default settings
//add options param to pass in
//options should include stuff related to layout type and common actions binding
//should also include some default columns and overrides. ==BUT== this has implications for default data mapping?

//CHANGE other settings to use settings object

var ObjectTable = function(options){
    var oThis = this;
    oThis.defaults = {
        debug: false,
        endpoint: null,
        containerID: null,
        columns: [],
        dataTransform: function(response,oTable){ //this is unlikely to work for anything, but serves as a reference template
            var aTransformed = [];
            response.results.forEach(function(element,index) {
                aTransformed.push(element);
            });
            return aTransformed;
        },
        classes: 'table table--fillEven table--flat',
        paginate: true,
        inlineSort: false,
        params: {
            page: 1,
            page_size: 25,
            order_by: null,
            direction: null
        },
        filters: {} //these are kept separate from params, and are controlled by UI outside the table
    }
    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.count = 0;
    oThis.Actions = Reflux.createActions(['fetchData','refresh']);
    oThis.msgStack = new MessageStack();
    oThis.createStore();
    oThis.handleStack = function(){
        oThis.msgStack.Display();
        oThis.msgStack.Clear();
    }

    //React components

    //ObjectTable
    oThis.ObjectTable = createReactClass({

        mixins: [Reflux.connect(oThis.TableStore, 'tablestore')],

        getInitialState: function() {
            return {
                params: $.extend({}, oThis.settings.params)
            }
        },

        onChangePage: function(page) {
            this.setState({
                params: $.extend(true, {}, oThis.settings.params, this.state.params, { page: page } )
            });
        },

        onChangeSort: function(sortBy,sortOrder) {
            this.setState({
                params: $.extend(true, {}, oThis.settings.params, this.state.params, { order_by: sortBy, direction: sortOrder } )
            });
        },

        componentDidMount: function(){
            //console.log(this.state);
        },

        componentDidUpdate: function(prevProps, prevState){
            if(prevState.params.page != this.state.params.page || prevState.params.order_by != this.state.params.order_by || prevState.params.direction != this.state.params.direction){
                //console.log("page state changed, old " + prevState.params.page + ", vs new " + this.state.params.page);
                //oThis.Actions.fetchData(oThis.settings.endpoint + formatParams(this.state.params));
                oThis.Actions.fetchData(this.state.params);
            }
        },

        render: function() {
            var oComponent = this;
            var columns = oThis.settings.columns;
            var sortFunction = oThis.settings.inlineSort ? null : oComponent.onChangeSort; //when null, Table component will sort inline, sort state not passed back to ObjectTable
            if(this.state.tablestore){
                var totalPages = 1;
                totalPages = Math.ceil(oThis.count / this.state.params.page_size);
                var defaultSort = this.state.params.order_by ? this.state.params.order_by : null;
                var defaultorder = this.state.params.direction ? SORT_STRING.indexOf(this.state.params.direction) : null;
                return (
                    <div>
                        <Table columns={oThis.settings.columns} data={this.state.tablestore} defaultSort={defaultSort} defaultorder={defaultorder} className={oThis.settings.classes} onChangeSort={sortFunction} />
                        {(function(){
                            if (oThis.count == 0) {
                              return (<div className="alert alert--information" role="status">No records to display.</div>);
                            }
                            if (oThis.settings.paginate && totalPages > 1) {
                              return (<TablePagination max={totalPages} onChange={oComponent.onChangePage}/>);
                            }
                        })()}
                    </div>
                );

            } else {
                return (
                    <div><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                );
            }

        }
    });

};


ObjectTable.prototype.renderTable = function(containerID) {
    var oThis = this;
    oThis.settings.containerID = containerID;
    ReactDOM.render(<this.ObjectTable />, document.getElementById(oThis.settings.containerID));
}

//REFLUX STORE
ObjectTable.prototype.createStore = function() {
    var oThis = this;

    oThis.TableStore = Reflux.createStore({
        listenables: oThis.Actions,
        rows: [],
        init: function() {
            //this.onX();
        },

        getInitialState: function() {
            this.onFetchData();
        },

        onRefresh: function() {
            this.onFetchData();
        },

        onFetchData: function(oParams) {
            var oStore = this;
            var endpoint;
            var oParams = oParams || {};
            //convert filters into keyed values
            var filters = $.extend( {}, oThis.settings.filters );
            for (filter in filters) {
                var value = null;
                var selector = filters[filter];
                var $filter = $(selector);
                var isCheckbox = $filter.is(":checkbox");
                if(isCheckbox){
                    //console.log('is checkbox, is checked: ', $filter.prop('checked'));
                    value = $filter.prop('checked');
                } else {
                    if($filter.val() != null && $filter.val().length > 0){
                        value = $filter.val();
                    } else {
                        value = null;
                    }
                }

                if(isCheckbox && $filter.data('checkedonly') && value==false ) {
                    delete filters[filter];
                } else {
                    filters[filter] = value;
                }

            }
            //console.log(filters,oThis.settings.params, oParams);
            var allparams = $.extend( {}, oThis.settings.params, filters, oParams);
            //console.log(allparams);
            endpoint = oThis.settings.endpoint + formatParams(allparams);

            //console.log(endpoint)
            httpGet(endpoint).then(
                function(value) {
                    var response = JSON.parse(value);
                    if(oThis.settings.debug){
                        console.log(response);
                    }
                    //console.log(response);
                    var nCount = response.lenth;
                    if(response.count != undefined){
                        nCount = response.count;
                    }
                    oThis.count = nCount;
                    var aTransformed = oThis.settings.dataTransform(response,oThis);
                    oStore.rows = aTransformed;
                    oStore.trigger(oStore.rows);
                })
            .catch(
                function(reason) {
                    console.error('Error loading table items.', reason);
                });

        }

    });
}

//Simple function for making simple Table and reusable custom cells

function SimpleTable(containerID,options) {
    var oThis = this;
    oThis.defaults = {
        containerID: null,
        columns: [],
        data: [],
        classes: 'table table--fillEven table--flat'
    }
    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.settings.containerID = containerID;
    if(oThis.settings.containerID != null && oThis.settings.columns.length > 0){
        ReactDOM.render(<Table columns={oThis.settings.columns} data={oThis.settings.data} className={oThis.settings.classes} />, document.getElementById(oThis.settings.containerID));
    }
}
